import { deepMerge } from 'js/utils/Utils'

const defaults = {
  $names: {
    trigger: '[data-gnav-dropdown-trigger]',
    target: '[data-gnav-dropdown-target]',
    parent: '[data-gnav-dropdown-group]',
  },
  attrNames: {
    trigger: 'data-gnav-dropdown-trigger',
    target: 'data-gnav-dropdown-target',
  },
}

export default class GNavDropdownController {
  $contentRoot = document.body
  $triggers = null
  $targets = null
  $parents = null

  constructor(options = {}) {
    deepMerge(this, defaults, options)
  }

  init() {
    this._set$()
    this._bindEvents()
    this._bindGlobalCloseEvents()
  }

  _set$() {
    this.$triggers = this.$contentRoot.querySelectorAll(this.$names.trigger)
    this.$targets = this.$contentRoot.querySelectorAll(this.$names.target)
    this.$parents = this.$contentRoot.querySelectorAll(this.$names.parent)
  }

  _bindEvents() {
    this.$parents.forEach(($wrapper) => {
      const $trigger = $wrapper.querySelector(this.$names.trigger)
      const key = $trigger?.getAttribute(this.attrNames.trigger)
      const $target = this.$contentRoot.querySelector(`[${this.attrNames.target}="${key}"]`)

      if (!$trigger || !$target) return

      // // focusin: フォーカス時に開く（Tabキー移動含む）
      // $wrapper.addEventListener('focusin', () => {
      //   this._openDropdown($trigger, $target)
      // })
      //
      // // focusout: フォーカス完全離脱で閉じる
      // $wrapper.addEventListener('focusout', (e) => {
      //   const next = e.relatedTarget
      //   if (!next || !$wrapper.contains(next)) {
      //     this._closeDropdown($trigger, $target)
      //   }
      // })

      // click: トグル
      $trigger.addEventListener('click', (e) => {
        e.preventDefault()

        const willOpen = !$target.classList.contains('is-open')
        this.closeAllDropdowns()

        if (willOpen) {
          this._openDropdown($trigger, $target)
        }
      })
    })
  }

  _openDropdown($trigger, $target) {
    $trigger.setAttribute('aria-expanded', 'true')
    $target.classList.add('is-open')
  }

  _closeDropdown($trigger, $target) {
    $trigger.setAttribute('aria-expanded', 'false')
    $target.classList.remove('is-open')
  }

  closeAllDropdowns() {
    this.$targets.forEach(($target) => $target.classList.remove('is-open'))
    this.$triggers.forEach(($trigger) => $trigger.setAttribute('aria-expanded', 'false'))
  }

  _bindGlobalCloseEvents() {
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        this.closeAllDropdowns()
      }
    })

    document.addEventListener('click', (e) => {
      const isInside = e.target.closest(this.$names.parent)
      if (!isInside) {
        this.closeAllDropdowns()
      }
    })
  }
}